import { DateTime } from "luxon";
import type { Department } from "../../contexts/AuthProvider";
import { getJobDisplayName } from "../../utils/roles";
import type { EmployeeChangeLogField } from "./useEmployeeChangelogQuery";

const formatValue = (val: unknown): string => {
	if (val === null || val === undefined) return "—";
	if (typeof val === "boolean") return val ? "Yes" : "No";
	if (val instanceof DateTime) return val.toFormat("MMM d, yyyy HH:mm");
	if (Array.isArray(val)) {
		return val
			.map((item) => {
				if (item instanceof DateTime) return item.toFormat("MMM d, yyyy");
				if (item !== null && typeof item === "object") return JSON.stringify(item);
				return String(item ?? "—");
			})
			.join(", ");
	}
	if (typeof val === "object") return JSON.stringify(val);
	return String(val);
};

export const resolveFieldValue = (field: EmployeeChangeLogField, val: unknown, dept: Department): string => {
	if (field === "job_ids" && Array.isArray(val)) {
		if (val.length === 0) return "—";
		return val.map((id) => getJobDisplayName(String(id), dept) || "unfamiliar job").join(", ");
	}
	return formatValue(val);
};
